var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g({ref:"inputLong",staticClass:"saved-input-long",attrs:{"placeholder":"ESCRIBIR"}},_vm.handlers))}
var staticRenderFns = []

export { render, staticRenderFns }